import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Divider, makeStyles, Typography } from '@material-ui/core';
import { Box } from '@react-three/drei';

import carabaya from '../../../../assets/img/SedeCarabaya.png';
import crillon from '../../../../assets/img/SedeCrillon.png';
import limaCargo from '../../../../assets/img/SedeLimaCargo.png';
import mallPlaza from '../../../../assets/img/SedeMallPlaza.png';
import surquillo from '../../../../assets/img/SedeSurquillo.png';
import { GetCourseByUser } from '../../../../services/courses';

const useStyles = makeStyles((theme) => ({
  containerSidebar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2, 1),
  },
  title: {
    fontFamily: 'Raleway',
    margin: theme.spacing(0),
    fontSize: '22px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: theme.palette.background.primary,
  },
  containerSede: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    maxWidth: 260,
    margin: theme.spacing(1.5, 0, 1.5, 0),
  },
  imgSede: {
    width: '70px',
    borderRadius: '50%',
    margin: theme.spacing(1),
  },
  titleSede: {
    fontFamily: 'Raleway',
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.common.pink,
  },
  themeSede: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: 500,
    marginTop: theme.spacing(0.5),
  },
}));
function SideBar() {
  const classes = useStyles();
  const params = useParams();
  const [showThemes, setShowThemes] = useState([]);
  const { sub } = useSelector((store) => store.login);

  const imgSedes = [crillon, carabaya, limaCargo, mallPlaza, surquillo];
  const nameSedes = ['Sede Crillon', 'Sede Carabaya', 'Sede Lima Cargo', 'Sede MallPlaza', 'Sede Surquillo'];

  const getListThemesBySelectedCourse = async () => {
    const { course } = params;
    const courseById = await GetCourseByUser(sub, course);
    const { data } = courseById;
    const { finalProjectByUser } = data[0];
    const dataFinalProject = {
      name: 'Proyecto Final',
      ...finalProjectByUser,
    };
    const dataOrder = data[0].topicsByUser.sort((a, b) => a.createdAt - b.createdAt);
    dataOrder.push(dataFinalProject);
    const content = dataOrder.map(
      (e, index) => {
        const { name } = e;
        return {
          index,
          name,
          nameSede: nameSedes.find((i, indexName) => index === indexName),
          img: imgSedes.find((_i, indexImg) => indexImg === index),
        };
      },
    );
    setShowThemes(content);
  };
  useEffect(() => {
    getListThemesBySelectedCourse();
  }, []);
  return (
    <div>
      <Box className={classes.containerSidebar}>
        <Typography className={classes.title}> Ruta de aprendizaje</Typography>
        { showThemes.map((theme) => (
          <Box key={theme.img}>
            <Box className={classes.containerSede} key={theme.name}>
              <img alt="sede" src={theme.img} className={classes.imgSede} />
              <Box>
                <Typography className={classes.titleSede}>{theme.nameSede}</Typography>
                <Typography className={classes.themeSede}>
                  Tema:
                  {' '}
                  {theme.name}
                </Typography>
              </Box>
            </Box>
            <Divider />
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default SideBar;
